var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { ref: "manageForbiddenFontRef", staticClass: "manage-forbidden-font" }, [_vm._t("default"), _vm._v(" "), _c('div', { staticClass: "manage-forbidden-font-list" }, [_c('div', { staticClass: "font-list-item" }, [_c('div', [_vm._v(_vm._s(_vm.$t('basic.forbiddenFontDialog.forbiddenFont')))]), _vm._v(" "), _c('div', { staticClass: "font-list-item-right" }, [_vm._v("\n        " + _vm._s(_vm.$t('basic.forbiddenFontDialog.replaceFont')) + "\n      ")])]), _vm._v(" "), _vm._l(_vm.forbiddenFontList, function (fontItem, language) {
    return _c('div', { key: language }, [_c('div', { staticClass: "font-title" }, [_vm._v(_vm._s(language))]), _vm._v(" "), _vm._l(fontItem, function (font, index) {
      return _c('div', { key: index, staticClass: "font-list-item" }, [_c('div', { staticClass: "postscriptNameImg" }, [font.forbiddenFont.thumb_url ? _c('img', { staticClass: "font-img", attrs: { "src": font.forbiddenFont.thumb_url, "alt": font.forbiddenFont.postscript_name } }) : _c('span', [_vm._v(_vm._s(_vm.getPostscriptName(font.forbiddenFont.postscript_name)))])]), _vm._v(" "), _c('font-layer', { staticClass: "font-layer", attrs: { "config": _vm.fontSelectorConfig, "requestParams": {
            tool: _vm.tool // 1.ps工具 2.视频工具
          }, "model": font.newFont, "font-selector-loading": _vm.fontSelectorLoading, "layer-dialog-config": {
            appendToBody: false
          }, "asset-font-config": _vm.assetFontConfig, "offset-config": {
            right: '-458',
            top: '15vh',
            height: _vm.offsetConfigHeight
          }, "langConfig": {
            title: _vm.$t('basic.fontLoader.title'),
            switchLoadText: _vm.$t('basic.fontLoader.loading'),
            system: _vm.$t('basic.fontLoader.systemFont'),
            forbidden: _vm.$t('basic.fontLoader.forbidden'),
            filter: {
              applyLabel: _vm.$t('workbench.resourceManagers.filter.apply'),
              clearLabel: _vm.$t('workbench.resourceManagers.filter.clear'),
              searchPlaceholder: _vm.$t('workbench.resourceManagers.searchPlaceholder')
            },
            currentFont: _vm.$t('basic.fontLoader.currentFont'),
            systemFont: _vm.$t('basic.fontLoader.systemFont'),
            assetFont: _vm.$t('basic.fontLoader.assetFont'),
            result: _vm.$t('workbench.resourceManagers.searchResults'),
            all: _vm.$t('basic.fontLoader.all'),
            return: _vm.$t('workbench.resourceManagers.back')
          } }, on: { "update-field": function updateField($event) {
            return _vm.updateFont($event, language, index);
          } } })], 1);
    })], 2);
  })], 2)], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };